import { G_VideoRatingCategory } from "~/lib/graphql";

export const BLOCK_RATINGS = [
  G_VideoRatingCategory.R18Adult,
  G_VideoRatingCategory.R18Gravure,
  G_VideoRatingCategory.R18,
  G_VideoRatingCategory.R15,
];
